module.exports = __webpack_public_path__ + "static/media/icone256-chat.6c5faa6e.png";